import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import useApi from '../../utility/apiCall';
import API_URL from '../../config/config';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth, getLoggedInUserData } from '../../context/AuthContext';

import FlashMessage from '../../components/FlashMessage';
import Loaders from '../../components/Loader';



// import ReactTooltip from 'react-tooltip';

// Icons & Images Files
import Breadcrumb from '../../components/Breadcrumb'
import Icons from '../../components/icons';
import Alert from "../../components/Alert";
import Pagination from "../../components/Pagination";
import SortIcons from "../../components/SortIcons";
import { Icon } from "@mui/material";


const PageAffiliate = () => {

  //Auth related var

  const { apiCall } = useApi();
  const navigate = useNavigate();
  const { state, dispatch } = useAuth();
  const token = state.token || '';
  const isInitialMount = useRef(true);


  //Loader
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [requestSubmitError, setRequestSubmitError] = useState(false);
  const [requestSubmitErrorMsg, setRequestSubmitErrorMsg] = useState(false);
  const [requestSubmitSuccess, setRequestSubmitSuccsess] = useState(false);
  const [requestSubmitSuccessMsg, setRequestSubmitSuccessMsg] = useState('');

  const [referralLink, setReferralLink] = useState('');
  const [affilateData, setAffilateData] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const copyClick = (value) => {
    setRequestSubmitSuccsess(false);
    setRequestSubmitError(false);
    navigator.clipboard.writeText(value)
      .then(() => {
        setRequestSubmitSuccsess(true);
        setRequestSubmitSuccessMsg('Text copied to clipboard');
        // console.log('Text copied to clipboard');
      })
      .catch((error) => {
        setRequestSubmitError(true)
        setRequestSubmitErrorMsg('Error copying text')
        // console.error('Error copying text: ', error);
      });
  };

  // const [isAffiliate, setAffiliate] = useState(1);

  // Early redirection based on isAffiliate
  // useEffect(() => {
  //   if (isAffiliate == 0) {
  //     navigate('/home');
  //   }
  // }, [isAffiliate, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const loggedInUser = getLoggedInUserData();
      const isUserLoggedIn = !!loggedInUser;

      if (isUserLoggedIn) {
        if (loggedInUser.id && token) {
          try {
            if (isInitialMount.current) {
              await getReferralLink();
              isInitialMount.current = false;
            }
            await getAffilateDetails(currentPage);
            setDataLoaded(true);
          } catch (error) {
            navigate('/login');
            console.error('Failed to fetch ib data:', error);
          }
        }
      }
    };

    fetchData();
  }, [token, currentPage]);

  // const [isAffiliate, setAffiliate] = useState(1);
  // useEffect(() => {
  //   if(isAffiliate != 1){
  //     navigate('/home');
  //   }
  // },[isAffiliate])

  //  const checkAffiliateAvailable = async () => {
  //     try {
  //       // setIsLoading(true);
  //       // console.log({id});
  //       const response = await apiCall(API_URL +'check-affiliate-available', {
  //           user_id: state.userData.id,
  //           token: token
  //       });
  //       if (response.data.success == '0') {
  //         // console.log(response.data.data);
  //         setAffiliate(response.data.data);
  //         // setTotalPagesDailySummary(response.data.data.last_page)
  //       }
  //       // setIsLoading(false);
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  //   };

  const getReferralLink = async () => {
    try {
      setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-referral-link', {
        user_id: state.userData.id,
        token: token,
      });
      if (response.data.success == '0') {
        //   console.log('Affilite refreeal ', response.data.data);
        setReferralLink(response.data.data.referral_link);
        //   setTotalPagesTradingHistory(response.data.data.last_page)
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getAffilateDetails = async (page = 1) => {
    try {
      setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-affilate-details', {
        user_id: state.userData.id,
        token: token,
        page: page,
        per_page: 10
      });
      if (response.data.success == '0') {
        console.log('Affilite refreeal ', response.data.data);
        setAffilateData(response.data.data);
        setTotalPages(response.data.data.pagination.last_page);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handleToNavigate = () => {
    navigate('/payouts')
  }
  return (
    <>
      {!dataLoaded && <Loaders />}

      <Breadcrumb className="" breadcrumbIcon="AffiliateSvg" breadcrumbHeading="Affiliate" />
      <div className='container-lg cl-custome3'>
        <div className='row row-gap-4'>

          <div className="col-12">
            <div class="referral-code-bx">
              <div className="rcb-content-bx">
                <div className="rcb-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.6674 17.5H8.33407M1.91227 4.84987C1.90032 3.64041 2.55238 2.511 3.60578 1.91662M18.0859 4.84987C18.0979 3.64042 17.4458 2.511 16.3924 1.91663M15.0007 6.66663C15.0007 5.34054 14.474 4.06877 13.5363 3.13109C12.5986 2.19341 11.3268 1.66663 10.0007 1.66663C8.67465 1.66663 7.40289 2.19341 6.4652 3.13109C5.52752 4.06877 5.00074 5.34054 5.00074 6.66663C5.00074 9.24178 4.35113 11.0049 3.62546 12.1711C3.01334 13.1549 2.70729 13.6467 2.71851 13.7839C2.73093 13.9359 2.76312 13.9938 2.88555 14.0846C2.99612 14.1666 3.49456 14.1666 4.49145 14.1666H15.51C16.5069 14.1666 17.0054 14.1666 17.1159 14.0846C17.2384 13.9938 17.2705 13.9359 17.283 13.7839C17.2942 13.6467 16.9881 13.1549 16.376 12.1711C15.6503 11.0049 15.0007 9.24178 15.0007 6.66663Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div>
                  <div className="rcb-heading">Your Referral Code</div>
                  <div className="rcb-text">Use this URL to promote across different platforms and track your conversions on the referrals tab, this link is unique to you.</div>
                </div>
              </div>
              <div onClick={() => copyClick(referralLink)} class="rcb-btn "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" fill="none" stroke-width="1.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M17.3151 7.89014H9.8151C8.89463 7.89014 8.14844 8.63633 8.14844 9.5568V17.0568C8.14844 17.9773 8.89463 18.7235 9.8151 18.7235H17.3151C18.2356 18.7235 18.9818 17.9773 18.9818 17.0568V9.5568C18.9818 8.63633 18.2356 7.89014 17.3151 7.89014Z"></path><path d="M4.81445 12.8901H3.98112C3.53909 12.8901 3.11517 12.7145 2.80261 12.4019C2.49005 12.0894 2.31445 11.6655 2.31445 11.2234V3.72343C2.31445 3.2814 2.49005 2.85748 2.80261 2.54492C3.11517 2.23236 3.53909 2.05676 3.98112 2.05676H11.4811C11.9231 2.05676 12.3471 2.23236 12.6596 2.54492C12.9722 2.85748 13.1478 3.2814 13.1478 3.72343V4.55676"></path></svg>{referralLink}</div>
            </div>
          </div>


          <div className="col-12">
            <div className='common-box '>
              <div className='row row-gap-3 mb-3'>
                <div className='col-md-4'>
                  <div className="affiliate-data-item common-box">
                    <div className="adi-icon"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"></path></svg></div>
                    <div className="adi-heading">Total Purchased</div>
                    <div className="adi-data">{affilateData.countOfUser}</div>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="affiliate-data-item common-box">
                    <div className="adi-icon"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path></svg></div>
                    <div className="adi-heading">Total Earned</div>
                    <div className="adi-data">${affilateData.totalEarned > 0 ? affilateData.totalEarned.toFixed(2) : 0}</div>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className="affiliate-data-item common-box">
                    <div className="adi-icon"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" stroke="white" stroke-width="1.5" stroke-linejoin="round"><path d="M15.0003 9.55681L15.0003 6.22347L5.00033 6.22347V16.2235C5.00033 17.1439 5.74652 17.8901 6.66699 17.8901H13.3337C14.2541 17.8901 15.0003 17.1439 15.0003 16.2235V9.55681ZM15.0003 9.55681C16.8413 9.55681 18.3337 8.06442 18.3337 6.22347C18.3337 4.38252 16.8413 2.89014 15.0003 2.89014H5.00033C3.15938 2.89014 1.66699 4.38252 1.66699 6.22347C1.66699 8.06442 3.15938 9.5568 5.00033 9.5568"></path><path d="M11.6663 12.8902L10.5889 13.9676C10.2635 14.2931 9.73586 14.2931 9.41042 13.9676L8.33301 12.8902M9.99967 9.55688V13.7236"></path></svg></div>
                    <div className="adi-heading">Total Paid Out</div>
                    <div className="adi-data">${affilateData.totalPaidOut > 0 ? affilateData.totalPaidOut.toFixed(2) : 0}</div>
                  </div>
                </div>

                <div className="col-12">
                  <div class="affiliates-work-bx">
                    <div className="awb-content-bx">
                      <div className="acb-icon">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.3024 3.75545C18.3024 3.75545 18.4491 2.26817 18.0899 1.90906M18.0899 1.90906C17.7287 1.54782 16.2438 1.69791 16.2438 1.69791M18.0899 1.90906L15.832 4.16697" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.3024 16.2445C18.3024 16.2445 18.4491 17.7318 18.0899 18.0909M18.0899 18.0909C17.7287 18.4522 16.2438 18.3021 16.2438 18.3021M18.0899 18.0909L15.832 15.833" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.91003 1.90905L4.16797 4.16697M1.91003 1.90905C2.27128 1.54782 3.75624 1.69791 3.75624 1.69791M1.91003 1.90905C1.55091 2.26817 1.69764 3.75544 1.69764 3.75544" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.91003 18.0909L4.16797 15.833M1.91003 18.0909C2.27128 18.4522 3.75624 18.3021 3.75624 18.3021M1.91003 18.0909C1.55091 17.7318 1.69764 16.2446 1.69764 16.2446" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.8346 10.0003C15.8346 13.222 13.223 15.8337 10.0013 15.8337C6.77964 15.8337 4.16797 13.222 4.16797 10.0003C4.16797 6.77867 6.77964 4.16699 10.0013 4.16699C13.223 4.16699 15.8346 6.77867 15.8346 10.0003Z" stroke="currentColor" stroke-width="1.25"></path><path d="M9.92703 7.75138C9.00653 7.75138 8.33203 8.28651 8.33203 8.90758C8.33203 9.52858 8.76695 9.91691 9.9987 9.91691C11.3555 9.91691 11.6654 10.5356 11.6654 11.1566C11.6654 11.7777 11.0723 12.2682 9.92703 12.2682M9.92703 7.75138C10.6527 7.75138 11.0363 8.00544 11.3392 8.34741M9.92703 7.75138V7.04785M9.92703 12.2682C9.20136 12.2682 8.9192 12.1248 8.51953 11.7632M9.92703 12.2682V12.9243" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"></path></svg>
                      </div>
                      <div>
                        <div className="acb-heading">Click on the link to know more about how affiliates work</div>
                      </div>
                    </div>
                    <div class="acb-btn">Visit Here</div>
                  </div>
                </div>

              </div>
              <div className='input-note text-center'>Please use the <span onClick={handleToNavigate}>payouts</span> section to request a payout</div>
            </div>
          </div>

          {(affilateData.wallets && affilateData.wallets.length > 0 && !isLoading) &&
            <div className="col-12">
              <div className='common-box'>

             
              <div class="common-box-heading cbh-small"> Affiliates History</div>

                <div className="table-responsive custom-table-responsive">
                  <table className="custom-table">
                    <thead>
                      <tr>
                        {/* <SortIcons /> */}
                        <th>REFERRAL COMPLETED AT</th>
                        <th>ACCOUNT SIZE</th>
                        <th>ACCOUNT TYPE</th>
                        <th>INCENTIVE/FEE</th>

                      </tr>
                    </thead>
                    <tbody>
                      {affilateData.wallets.map((wallet, index) => {
                            // Determine the percentage based on account_type.step
                            const step = (wallet.account_type.step || '').toLowerCase();
                            const percentage = step === '1 step' ? 10 :
                              step === '2 step' ? 15 :
                              step === 'instant' ? 10 :
                                0;

                            return (
                              <tr key={index}>
                                <td>{wallet.created_date_time_formattad || ''}</td>
                                <td>{wallet.account_size.limit || 0}</td>
                                <td><span class="td-status ts-step status-green4 ">{wallet.account_type.step || ''}</span></td>
                                <td>{
                                  (() => {
                                    const threshold = new Date('2026-03-06T00:00:00Z');
                                    const createdAt = wallet.created_at ? new Date(wallet.created_at) : (wallet.created_date_time_formattad ? new Date(wallet.created_date_time_formattad) : null);
                                    const basePrice = createdAt && createdAt < threshold
                                      ? parseFloat((wallet.account_size && wallet.account_size.old_price) ? wallet.account_size.old_price : (wallet.account_size ? wallet.account_size.price : 0))
                                      : parseFloat(wallet.account_size ? wallet.account_size.price : 0);
                                    return `$${(basePrice * (percentage / 100)).toFixed(2)}`;
                                  })()
                                }</td>
                              </tr>
                            );
                          })
                      }

                    </tbody>
                  </table>
                </div>
                {totalPages > 1 && (
                  <Pagination 
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    prev={handlePrevPage}
                    next={handleNextPage}
                  />
                )}

              </div>

            </div>
          }

        </div>
      </div>

      <FlashMessage type="success" isVisible={requestSubmitSuccess} message={requestSubmitSuccessMsg} />
      <FlashMessage type="error" isVisible={requestSubmitError} message={requestSubmitErrorMsg} />
    </>
  )
}

export default PageAffiliate
